import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { NavLink, withRouter } from "react-router-dom";

class MenuPanel extends Component {
  static propTypes = { menu: PropTypes.array }; //{name, route, component}
  static defaultProps = { menu: [] };

  render() {
    const { match, menu } = this.props;
    return (
      <Wrapper>
        <Title>SUPERVISOR SETTING</Title>
        {menu.map(row => (
          <Menu key={row.name} to={match.url + row.route}>
            {row.name}
          </Menu>
        ))}
      </Wrapper>
    );
  }
}

export default withRouter(MenuPanel);

const Wrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
  width: 200px;
`;
const Title = styled.div`
  color: ${props => props.theme.headerTitle};
  font-size: 1rem;
  margin-bottom: 20px;
`;
const Menu = styled(NavLink)`
  color: ${props => props.theme.uiText};
  margin-bottom: 10px;
  text-decoration: none;
  &:link {
    text-decoration: none;
  }
  &:active,
  &:visited,
  &.active {
    font-weight: bold;
    color: ${props => props.theme.uiText};
  }
  &:hover {
    font-weight: bold;
    color: black;
  }
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/MenuPanel.js